import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Text, Inline } from 'slate';
import Delta from 'quill-delta';
import convertMarksToAttributes from './convertMarksToAttributes';
import convertInlineToAttributes from './convertInlineToAttributes';
import { OT_BLOCKS } from '../../../types/BlockTypes';
import getNodeData from '../utils/getNodeData';

var convertTextToOperation = function convertTextToOperation(node, parent) {
  var markAttributes = convertMarksToAttributes(node);
  var inlineAttributes = Inline.isInline(parent) ? convertInlineToAttributes(parent) : {};
  return new Delta().insert(node.text, _objectSpread({}, markAttributes, {}, inlineAttributes));
};

var reduceNodeBlocks = function reduceNodeBlocks(memo, delta) {
  return memo.concat(delta);
};

export default function convertNodeToOperations(node, parent) {
  if (!node) return new Delta();

  if (Text.isText(node)) {
    return convertTextToOperation(node, parent);
  }

  if (OT_BLOCKS.includes(node.type)) {
    return node.nodes.map(function (childNode) {
      return convertNodeToOperations(childNode, node);
    }).reduce(reduceNodeBlocks, new Delta()).insert('\n', {
      type: node.type,
      data: getNodeData(node)
    });
  }

  return node.nodes.map(function (childNode) {
    return convertNodeToOperations(childNode, node);
  }).reduce(reduceNodeBlocks, new Delta());
}